import { PLATFORM_URLS } from '../constants/platformUrls.js';

const stripTrailingSlash = url => url.replace(/\/$/, '');

export const inferClientDeploymentTier = () => {
  const forced = process.env.REACT_APP_DEPLOYMENT_TIER;
  if (['local', 'dev', 'prod'].includes(forced)) {
    return forced;
  }

  if (typeof window === 'undefined') {
    return 'prod';
  }

  const hostname = window.location.hostname.toLowerCase();

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'local';
  }

  if (
    hostname.includes('submission-v2') ||
    hostname.includes('curator-dev') ||
    hostname.includes('api-curator-dev')
  ) {
    return 'dev';
  }

  return 'prod';
};

export const isNonProdClientDeployment = () => {
  const tier = inferClientDeploymentTier();
  return tier === 'local' || tier === 'dev';
};

const getPlatformBaseUrl = platform => {
  const tier = inferClientDeploymentTier();
  const defaults = PLATFORM_URLS[tier][platform];

  if (tier === 'prod') {
    const envOverride =
      platform === 'curator'
        ? process.env.REACT_APP_URL_CURATOR_PLATFORM
        : process.env.REACT_APP_URL_ARTIST_PLATFORM;

    if (envOverride) {
      return stripTrailingSlash(envOverride);
    }
  }

  return defaults;
};

export const getArtistPlatformLoginUrl = () => getPlatformBaseUrl('artist');

export const getCuratorPlatformLoginUrl = () => {
  const base = getPlatformBaseUrl('curator');
  return `${base}/?openLogin=true`;
};

export const getCuratorPlatformBaseUrl = () =>
  getCuratorPlatformLoginUrl().replace('/?openLogin=true', '');
